const QuickHelp = {
    namespaced: true,
    state: {
        count: null,
        items: [],
        route: null,
    },
    getters: {
        getItems: (state) => {
            return state.notifications;
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.items = data.items;
            state.count = data.items.length ? data.items.length : 0;
            state.route = data.route;
        },
    },
    actions: {
        fetchHelpPage({ commit, state }, route) {
            const fetchRoute = route.replace('http://localhost/api/v1/help-pages/data/', '');
            if (state.route === fetchRoute) {
                return;
            }
            axios.get(route).then((res) => {
                if (res.data && res.data.length) {
                    commit('SET_ITEMS', { items: res.data, route: fetchRoute });
                }
            });
        },
    },
};

export default QuickHelp;
